import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-us',
  template: `
    <h2>General Feedback</h2>

    <p>
      If you would like to submit questions or comments or provide general feedback on the Beltsville Area Information
      Repository Web site, please do so via the following link:<br />
      <a href="mailto:barcwebmaster@bmtdp.com?subject=General%20Feedback%20for%20the%20USDA%20BARC%20IR%2FAR%20Website">Contact Webmaster</a>
    </p>

    <h2>Directories</h2>

    <p>
      To find contact information of BARC personnel, please use this directory:<br />
      <a href="https://www.ars.usda.gov/people-locations/people-list/?modeCode=80-00-00-00#" target="_blank">BARC Personnel</a>
    </p>

    <p>
      To find contact information for ARS offices and personnel, please use one of the following directories:<br />
      <a href="https://www.ars.usda.gov/people-locations/find-a-person/" target="_blank">ARS Personnel</a><br />
      <a href="https://www.ars.usda.gov/people-locations/find-a-location/" target="_blank">ARS Locations</a>
    </p>

    <h2>Locations</h2>

    <p>
      Beltsville Area Research Center is located at:<br />
      10300 Baltimore Blvd.<br />
      Building 003, Room 223, BARC-WEST Beltsville, MD 20705
    </p>

    <p>
      ARS Headquarters is located at:<br />
      Jamie L. Whitten Building<br />
      1400 Independence Ave., S.W.<br />
      Washington DC, 20250<br />
      <a href="https://www.ars.usda.gov/docs/headquarters-information/" target="_blank">Additional Headquarters Information</a>
    </p>
  `
})
export class ContactComponent { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/contact.ts